import { render, staticRenderFns } from "./ResultFormSiBy.vue?vue&type=template&id=05c7ade5&scoped=true&"
import script from "./ResultFormSiBy.vue?vue&type=script&lang=js&"
export * from "./ResultFormSiBy.vue?vue&type=script&lang=js&"
import style0 from "./ResultFormSiBy.vue?vue&type=style&index=0&id=05c7ade5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c7ade5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05c7ade5')) {
      api.createRecord('05c7ade5', component.options)
    } else {
      api.reload('05c7ade5', component.options)
    }
    module.hot.accept("./ResultFormSiBy.vue?vue&type=template&id=05c7ade5&scoped=true&", function () {
      api.rerender('05c7ade5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/ResultFormSiBy.vue"
export default component.exports